// Throws a typed error; the message includes the offending shape so failures
// are debuggable without re-running. Matches the project rule "exception
// messages must include the offending value and expected shape."
export class InvariantViolation extends Error {
  constructor(message: string) {
    super(`Invariant failed: ${message}`);
    this.name = "InvariantViolation";
  }
}

export function invariant(
  condition: unknown,
  message: string,
): asserts condition {
  if (!condition) {
    throw new InvariantViolation(message);
  }
}
